import { VF_TIME_STAMP } from 'AppSrc/core/components/forms/form-base-components/utility/v-f-time-stamp';
import { DATE_ADDED } from './work-information-item-constants';

const fieldId = DATE_ADDED;

const validator = () => null;

const vFParams = {
};

const initialValues = null;

const dateAdded = {
  id: fieldId,
  validator,
  vFParams,
  initialValues,
  fieldType: VF_TIME_STAMP,

};

export { dateAdded };
